import { MetaTags } from '@cedarjs/web'
import { Box, Tabs, Tab } from '@mui/material'
import { useState } from 'react'
import LinkTasksTab from './components/LinkTasksTab'
import ViewLinkedTasksTab from './components/ViewLinkedTasksTab'

const TaskLinkingPage = () => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <>
      <MetaTags
        title="Task Linking"
        description="Link and manage maintenance item relationships"
      />
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}>
          <Tab label="Link Tasks" />
          <Tab label="View Linked Tasks" />
        </Tabs>

        {activeTab === 0 && <LinkTasksTab />}
        {activeTab === 1 && <ViewLinkedTasksTab />}
      </Box>
    </>
  )
}

export default TaskLinkingPage
